import React from 'react';
import { CommonHeader } from '../common/headerUtil';

const ProgramDefinition = () => {
  return (
    <>
      <CommonHeader titleText="Program Definition" />
      {/* Your component content goes here */}
      <h1>Program Definition</h1>
    </>
  );
};

export default ProgramDefinition;
